module.exports = __webpack_public_path__ + "files/27a8a9d5484937bedc8463eb37169f44.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lora-bolditalic-webfont.woff
// module id = 696
// module chunks = 60